import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Shield } from "@/components/Logo";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const sid = params.get("session_id");

  useEffect(() => {
    if (!sid) return setStatus("error");
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") return setStatus("paid");
        if (data.status === "expired" || tries > 8) return setStatus("error");
      } catch { if (tries > 8) return setStatus("error"); }
      tries++; setTimeout(poll, 2000);
    };
    poll();
  }, [sid]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cloud p-4">
      <div className="mb-card p-8 max-w-md text-center animate-scale-in">
        <div className="flex justify-center mb-4"><Shield size={56} /></div>
        {status === "checking" && <><Loader2 className="w-10 h-10 text-navy animate-spin mx-auto" /><h2 className="font-display text-2xl font-bold text-navy mt-4">Confirming your deposit…</h2></>}
        {status === "paid" && <><CheckCircle2 className="w-14 h-14 text-successg mx-auto" /><h2 className="font-display text-3xl font-extrabold uppercase text-navy mt-4">Deposit Received!</h2><p className="text-slate-500 mt-2">Your roof is officially on the schedule. Our production team will be in touch. Welcome to Masterbuilt.</p></>}
        {status === "error" && <><XCircle className="w-14 h-14 text-dangerr mx-auto" /><h2 className="font-display text-2xl font-bold text-navy mt-4">Payment not confirmed</h2><p className="text-slate-500 mt-2">If you completed checkout, it may take a moment. Otherwise please try again.</p></>}
        <Link to="/" className="inline-block mt-6 bg-navy text-white font-bold py-2.5 px-6 rounded-xl border-2 border-navy">Back to app</Link>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-cloud p-4">
      <div className="mb-card p-8 max-w-md text-center">
        <XCircle className="w-14 h-14 text-slate-400 mx-auto" />
        <h2 className="font-display text-2xl font-bold text-navy mt-4">Checkout canceled</h2>
        <Link to="/" className="inline-block mt-6 bg-navy text-white font-bold py-2.5 px-6 rounded-xl border-2 border-navy">Back to app</Link>
      </div>
    </div>
  );
}
